<template>
  <v-app>
    <div class="container">

       <loading :active.sync="busy"/>

      <!-- Header -->
      <header-simple></header-simple>

      <!-- Contents -->
      <div class="contents">

        <!-- Items -->
        <div class="items">
          <div class="item" v-if="step=='register'">
            <div class="header-title">
              {{ $t('signup.register_text') }}
            </div>
            <form-register :busy.sync="busy_register"/>
          </div>

          <div class="item" v-if="step=='plans'">
            <form-plans/>
          </div>

          <div class="item" v-if="step=='payment'">
            <form-payment :busy.sync="busy_payment"/>
          </div>

          <div class="item" v-if="step=='payment_auto'">
            <form-payment-auto :busy.sync="busy_payment_auto"/>
          </div>

        </div>

      </div>
    </div>

    <!-- Error modal -->
    <modal-error></modal-error>

  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Signup"
    }
  },

  data() {
    return {
      busy_register: false,
      busy_payment: false,
      busy_payment_auto: false,

      step: null,
    }
  },

  computed: {
    busy() {
      return this.busy_register || this.busy_payment || this.busy_payment_auto
    },

    code() {
      return this.$route.params.code
    },
  },

  watch: {
    code: {
      async handler(val) {
        let error = false

        let to_code = 'register'
        let to = {name: 'signupform', params: {code: 'register'}}
        
        let access_token = this.$store.getters['auth/access_token']
        if (!!access_token) {
          try {
            await this.$store.dispatch('user/getUserInfo')
            await this.$store.dispatch('welcome/getProducts')
            await this.$store.dispatch('user/getMyAutoPayments')
          } catch(e) {
            error = true
            let status = !!e.response ? e.response.status : '000'
            this.$store.commit('error/setErrorCode', status)
            this.$store.commit('error/setDialog', true)
          } finally {
            if (!error) {
              let is_permanent = this.$store.getters['user/is_permanent']
              let prod_id = this.$store.getters['welcome/prod_id']
              let products = this.$store.getters['welcome/products']
              let prod_auto = products.filter(v => v.kind == 4)[0].prod_id == prod_id ? true : false
              let has_plan = !!this.$store.getters['welcome/prod_id']
              let has_auto_payments = !!this.$store.getters['user/auto_payments'].length
              let username = this.$store.getters['user/username']
              if (is_permanent || has_auto_payments) {
                to = {name: 'lab'}
              }
              else if (!has_plan || val == 'plans') {
                to = {name: 'signupform', params: {code: 'plans'}}
                to_code = 'plans'
              }
              else if (has_plan || val == 'payment') {
                if (prod_auto) {
                  to = {name: 'signupform', params: {code: 'payment_auto'}}
                  to_code = 'payment_auto'
                } else {
                  to = {name: 'signupform', params: {code: 'payment'}}
                  to_code = 'payment'
                }
              } else {
                await this.$store.dispatch('auth/logout')
              }
            }
          }
        }
        this.step = to_code
        if (val != to_code) {
          this.$router.replace(to)
        }
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
  .container {
    width: 100vw;
    height: calc(100vh - 70px);
    margin-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .item {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    min-width: 327px;
    max-width: 450px;
    padding: 22px 40px 38px;
  }

  .header-title {
    padding: 10px 0 20px;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/spa/common/signup.vue